import { ContentItemType } from './ContentItemType';
import { MzImage } from '../../MzImage';
import { Mapper } from 'module/Common';

export type ContentImagesLinksElement = {
  readonly image: MzImage;
  readonly categoryId: false | number;
};

export namespace ContentImagesLinksElement {
  const create = (input: ContentImagesLinksElement) => input;

  export const mapper = Mapper.mapSchema(
    {
      image: MzImage.mapperSafe,
      category_id: Mapper.oneOf([Mapper.exact<false>(false), Mapper.num]),
    },
    ({ image, category_id }) => create({ image, categoryId: category_id })
  );
}

export type ContentImagesLinks = {
  readonly type: ContentItemType;
  readonly elements: Array<ContentImagesLinksElement>;
  readonly fullWidth: boolean;
};

export namespace ContentImagesLinks {
  const create = (input: ContentImagesLinks) => input;

  export const mapper = Mapper.mapSchema(
    {
      acf_fc_layout: Mapper.exact(ContentItemType.ImagesLinks),
      elements: Mapper.array(ContentImagesLinksElement.mapper),
      full_width: Mapper.bool,
    },
    ({ full_width, elements, acf_fc_layout }) => create({ elements, fullWidth: full_width, type: acf_fc_layout })
  );
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/item/ContentImagesLinks.ts